import LectureTasksPage from './lecture-tasks-page'

export default LectureTasksPage
